import { QueryClient } from '@tanstack/react-query'
import { isAuthError } from './api/errorHandler'

/**
 * Default query options
 */
const defaultQueryOptions = {
  queries: {
    retry: (failureCount, error) => {
      // Don't retry on auth errors
      if (isAuthError(error)) {
        return false
      }
      // Retry up to 2 times for other errors
      return failureCount < 2
    },
    staleTime: 1000 * 60, // 1 minute
    gcTime: 1000 * 60, // 1 minute (previously cacheTime)
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  },
  mutations: {
    retry: false, // Don't retry mutations
  },
}

/**
 * Create and configure React Query client
 */
export const queryClient = new QueryClient({
  defaultOptions: defaultQueryOptions,
})

/**
 * Query keys factory
 * Centralized place for all query keys
 */
export const queryKeys = {
  // Auth
  auth: {
    me: ['auth', 'me'],
  },

  // Leads
  leads: {
    all: ['leads'],
    list: (filters) => ['leads', 'list', filters],
    detail: (uuid) => ['leads', 'detail', uuid],
    stats: ['leads', 'stats'],
  },

  // Properties
  properties: {
    all: ['properties'],
    list: (filters) => ['properties', 'list', filters],
    detail: (id) => ['properties', 'detail', id],
  },

  // Clients
  clients: {
    all: ['clients'],
    list: (filters) => ['clients', 'list', filters],
    detail: (id) => ['clients', 'detail', id],
  },

  // Dashboard
  dashboard: {
    stats: ['dashboard', 'stats'],
  },

  // Users (for autocomplete, etc.)
  users: {
    autocomplete: (query) => ['users', 'autocomplete', query],
  },
}
